// components/Utils/RefreshWrapper.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import PullToRefresh from './PullToRefresh';

const RefreshWrapper = ({ children }) => {
    const location = useLocation();

    // Define which routes should NOT have pull-to-refresh
    const excludedRoutes = ['/FirstGame', '/SecondPage', '/viewgame'];
    const shouldDisableRefresh = excludedRoutes.some(route => location.pathname.includes(route));

    if (shouldDisableRefresh) {
        return <>{children}</>;
    }

    const handleRefresh = async () => {
        // Reload the page or refresh data
        window.location.reload();
    };

    return (
        <PullToRefresh onRefresh={handleRefresh}>
            {children}
        </PullToRefresh>
    );
};

export default RefreshWrapper;